<template>
  <div>
    <section class="content_section">
    <div style="display: flex; justify-content: space-between; padding-right: 2rem;">
      <h1 style="padding-left: 20px; margin-top: -1rem;">{{ options.Lang.Titelbilderverwaltung }}</h1>
    </div>

    <div style="padding: 20px;" v-if="renderComp">
      

      <div style="display:flex; align-items: baseline;">
                        <md-field class="md-focused" >
                          <label style="font-size: 18px; margin-bottom: 1rem;">{{ options.Lang.neues_Bild_hochladen + ": "}}</label>
                            <md-input tabindex="4" name="imgName" placeholder="Name" id="imgName"
                             v-model="imgName" style="margin-right: 2rem; color: black;"/>
                            </md-field>
                             <md-field>
                              <label for="selectedCat">{{options.Lang.Kategorie}}</label>
                  <md-select v-model="selectedCat" name="selectedCat" id="selectedCat" style="margin-right: 2rem;" place>
                    <md-option v-for="(cat, index)  in categories " :key="'index' + index" :value=cat.name>{{ cat.name }}</md-option>
                  </md-select>
              </md-field>

              <md-field>
                <input class="choose-file" type="file" tabindex="4" @change="getUploadImg" name="uploadFile"
                              id="uploadFile" accept="image/png, image/jpeg" style="width: 20rem; margin-right: 2rem;"/>

                            <md-button tabindex="7" class="md-raised md-primary"
                              style="min-width: 155px; height: 38px; margin: 10px 0px;"
                              @click="uploadImg(selectedCat)"><strong>{{options.Lang.Hochladen}}</strong>
                            </md-button>
              </md-field>
                            

                        
                      
                      </div><br>
      <!--/////////////////////////////////-->
      <div id="filterButtons" style="margin-left: -10px;">
        <md-button  tabindex="7" class="md-raised"
                    id="alle"
                    name="0"
                    style="min-width: 155px; height: 38px; margin: 10px 10px; background-color: lightgray; color: black;"
                    @click="selectCat('alle')"><strong>{{options.Lang.showAll}}</strong>
        </md-button>
        <md-button  tabindex="7" class="md-raised catButton"
                    v-for="(cat, index) in categories" :key="'index'+index"
                    :id="cat.name"
                    name="0"
                    style="min-width: 155px; height: 38px; margin: 10px 10px; background-color: lightgray; color: black;"
                    @click="selectCat(cat.name)"><strong>{{cat.name}}</strong>
        </md-button>
      </div>
      <br><br>
      <!--/////////////////////////////////-->
      
        <div class="imgContainer" style="row-gap: 20px;" v-if="imgs.length > 0">
                            <div style="margin-right: 18px;" v-for="(img, index) in selectedImgs" :key="index">
                              <img
                                  class="imgbgchoice"
                                  :src="'./titleImgs/thumbs/' + img.img.replace('titleImgs/', '')"
                                  @error="onImageError($event, img.img)"
                                  @click="showModalForPic(img)"
                                  loading="lazy"
                                  width="129"
                                  height="85"
                              />
                              <md-tooltip  v-if="img?.imageName" md-delay="300" md-direction="bottom">{{ img.imageName }}</md-tooltip>
                            </div>
                          </div>
      <!--/////////////////////////////////-->


      
      <div class="editCat" v-if="showLastQuestion" id="lastQuestion">
          <div class="contentEdit2 md-elevation-10">
            <div class="md-layout-item">
                <p v-if="!imgCheckError">{{ options.Lang.Bild_löschen }}</p>
                <p v-if="imgCheckError && anzahlErrorTrips == 1">{{ anzahlErrorTrips }}<span>{{options.Lang == options.German ? imgCeckErrorMsgOneDe : imgCeckErrorMsgOneEn }}</span></p>
                <p v-if="imgCheckError && anzahlErrorTrips > 1">{{ anzahlErrorTrips }}<span>{{options.Lang == options.German ? imgCeckErrorMsgOneDe : imgCeckErrorMsgOneEn }}</span></p>
                <div style="float: right;">
                  <md-button tabindex="8" class="md-raised secondary" @click="closeQuestion()"><strong>{{options.Lang.Fenster_schließen}}</strong></md-button>
                  <md-button tabindex="7" class="md-raised md-primary" @click="rmvImg()">{{options.Lang.löschen}}
                  </md-button>
                </div>
            </div>
        </div>
      </div>


      <div class="editCat" v-if="ModalPic" id="modalPic">
          <div class="contentEdit3 md-elevation-10">
            <div style="display: flex;">
              <div style="height: 13.5rem; width: 20rem;">
                <img :src="'./' + actualImg.img" style="" width="100%" height="100%">
              </div>
              <div style="margin-left: 5rem;">
                <md-field>
                  <label style="font-size: 18px; margin-bottom: 1rem;">{{ options.Lang.changePicName }}</label>
                  <md-input tabindex="4" name="imgName" :value="actualImg.imageName" id="imgName"
                             v-model="selectedNameImg" @input="checkInput" />
                             <md-button tabindex="8" class="md-raised secondary" id="uploadButton" disabled @click="changeNameForImg(actualImg)"><strong>{{options.Lang.Speichern}}</strong></md-button>

                </md-field>
                <br>
                <md-field>
                  <label>{{ options.Lang.changePicCat }}</label>
                  <md-select v-model="selectedCatImg" name="selectedCat" id="selectedCat">
                    <md-option v-for="(cat, index)  in categories " :key="'index' + index" :value=cat.name>{{ cat.name }}</md-option>
                  </md-select>
                  <md-button tabindex="8" class="md-raised secondary" @click="changeCatForImg(actualImg)"><strong>{{options.Lang.Speichern}}</strong></md-button>
                </md-field>
<br>
                <md-field style="float: right !important; padding-left: 4.8rem !important">
                  <md-button tabindex="8" class="md-raised secondary" @click="rmvImgCheck(actualImg)"><strong>{{options.Lang.löschen}}</strong></md-button>
                  <md-button tabindex="8" class="md-raised md-primary" @click="closeModalPic()"><strong>{{options.Lang.Fenster_schließen}}</strong></md-button>

                </md-field>


              </div>
            </div>
        </div>
      </div>


    </div>

    <Success :options="options"></Success>
    </section>

  </div>
 

</template>

<script>
import * as moment from 'moment'
import Success from '../../components/dialogs/Success.vue'
import Brand from '../../components/dialogs/editBrand.vue'



export default {
  name: 'settings',
  components: {
    Success, Brand
  },
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedCatImg: null,
      ModalPic: false,
      actualImg: null,
      anzahlErrorTrips: 0,
      imgCheckError: false,
      imgCeckErrorMsgOneDe: " Trip benutzt zurzeit dieses Titelbild. Soll das Bild trotzdem gelöscht werden?",
      imgCeckErrorMsgMoreDe: " Trips benutzen zurzeit dieses Titelbild. Soll das Bild trotzdem gelöscht werden?",
      imgCeckErrorMsgOneEn: " Trips are currently using this cover photo. Should the photo be deleted anyway?",
      imgCeckErrorMsgMoreEn: " Trips are currently using this cover photo. Should the photo be deleted anyway?",
      showLastQuestion: false,
      renderComp: false,
      categories: [],
      imgs: [],
      selectedImgs: [],
      selectedCats: [],
      selectedCat: null,
      newImg: null,
      titelCount: null,
      MainCat: null,
      imgName: null,

    }
  },
  beforeCreate() {
  },
  beforeMount() {
  },
  created() {
    
  },
  updated(){
    if(this.selectedNameImg == null || this.selectedNameImg == "" ||  this.selectedNameImg == "null"){
      let button = document.getElementById("uploadButton")
      if(button != null){
        button.setAttribute("disabled", true)
      }
    }else{
      let button = document.getElementById("uploadButton")
      if(button != null){
        button.removeAttribute("disabled")
      }
    }
  },
  async mounted() {
    this.options.showBrandSettings = true
    this.renderComp = false;

    await this.getAllCats();
    await this.getAllImgs();

    this.renderComp = true;

    this.$nextTick(() => {
      this.selectCat('alle')
      });
    

  },
  methods: {
    checkInput(){
      if(this.selectedNameImg == null || this.selectedNameImg == "" ||  this.selectedNameImg == "null"){
      let button = document.getElementById("uploadButton")
      button.setAttribute("disabled", true)
      }else{
        let button = document.getElementById("uploadButton")
        button.removeAttribute("disabled")
      }
    },
    onImageError(event, fallbackPath) {
      event.target.src = './' + fallbackPath;
    },
    async changeNameForImg(img){
      this.renderComp = false;
      let myData = {
        newName: this.selectedNameImg,
        id: img.id
      }
      let self = this;
      await self.doPost({ data: myData }, 'changeNameForImg', async function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          //do stuff
          self.options.showSuccess = true;
          self.renderComp = true;

          await self.getAllCats();
          await self.getAllImgs();


          self.$nextTick(() => {
            self.selectCat('alle')
          });
              }
            });
    },
    async changeCatForImg(img){
      let myData = {
        imgName: img.img,
        cat: this.selectedCatImg
      }
      let self = this;
      await self.doPost({ data: myData }, 'changeCatForImg', async function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
          self.renderComp = true;

          await self.getAllCats();
          await self.getAllImgs();


          self.$nextTick(() => {
            self.selectCat('alle')
          });
        }
      });


    },
    closeModalPic(){
      this.ModalPic = false;
      this.actualImg = null;
    },
    showModalForPic(img){
      
      this.actualImg = img;

      this.categories.forEach(cat =>{
       
        if(img.categorie == cat.name){
          this.selectedCatImg = cat.name;
          this.selectedNameImg = img.imageName;
        }
      })

      this.ModalPic = true;

    },
    buildSelectedImgs(){
      this.selectedImgs = [];
      for(let i = 0; i < this.selectedCats.length; i++){
        this.imgs.forEach(pic =>{
          if(pic.categorie == this.selectedCats[i]){
            this.selectedImgs.push(pic)
          }
        })
      }
    },
    async selectCat(catname){

      if(catname != 'alle'){
        let button = document.getElementById(catname)

        if(button.name == "0"){
        button.name = "1"
        button.style.backgroundColor = "black"
        button.style.color = "lightgray"


        let alleButton = document.getElementById("alle");
        alleButton.style.backgroundColor = "lightgray";
        alleButton.style.color = "black";


        this.selectedCats.push(catname)
        this.buildSelectedImgs();

        return;
        }
        if(button.name == "1"){
          button.name = "0"
          button.style.backgroundColor = "lightgray"
          button.style.color = "black"

          this.selectedCats = this.selectedCats.filter(item => item !== catname);
          this.buildSelectedImgs();

          return;
        }
      }else{
        let button = document.getElementById('alle')
        if(button.name == "0"){
        button.name = "1"
        button.style.backgroundColor = "black"
        button.style.color = "lightgray"

        this.selectedCats = []
        this.selectedImgs = this.imgs

        let elements = document.getElementsByClassName("catButton");

        if(elements.length > 0){
          for(let i = 0; i < elements.length; i++){
            elements[i].style.backgroundColor = "lightgray"
            elements[i].style.color = "black"

          }
        }

        return;
        }
        if(button.name == "1"){
          button.name = "0"
          button.style.backgroundColor = "lightgray"
          button.style.color = "black"

          this.selectedCats = []
          this.selectedImgs = []

          return;
        }
      }

      this.renderComp = true;
      
    },
    closeQuestion(){
      this.showLastQuestion = false;
    },
    async rmvImgCheck(img){
      this.myImg = img;
      let self = this;
      self.imgCheckError = false;
      self.anzahlErrorTrips = 0;
      await self.doPost({ data: img.img }, 'rmvImgCheck', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data.length
          if(result > 0){
            if(self.options.Lang == self.options.German){
              self.anzahlErrorTrips = result;
              self.imgCheckError = true;
              self.showLastQuestion = true;
            }else{
              self.anzahlErrorTrips = result;
              self.imgCheckError = true;
              self.showLastQuestion = true;
            }
          }else{
            self.showLastQuestion = true;
          }
        }
      });
     
    },
    async rmvImg() {
      let self = this;
      await self.doPost({ data: this.myImg.img }, 'rmvImg', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
      
        }
      });
      await self.doPost({ data: self.myImg.img }, 'rmvImgFromTrip', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
         
        }
      });
     
      self.showLastQuestion = false;
      await self.getAllImgs();
      await location.reload();
    },
    async getAllCats(){
      let self = this;
    self.doPost({}, 'getAllCategoriesToImages', function (res) {
      if (res.data.status === 'error') {
        this.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.categories = result;
       
      }
    });
    },
    async getAllImgs(){
      let self = this;
      self.doPost({}, 'getFirstImages', function (res) {
      if (res.data.status === 'error') {
        this.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.imgs = result;
       
        self.selectedImgs = self.imgs;
      }
    });
    },
    getUploadImg(event) {
      this.newImg = event.target.files[0];
      
    },
    
    async uploadImg(cat) { 
      this.renderComp = false;
      if(cat == null || cat == "" || cat == undefined){
        this.categories.forEach(cat => {
          if(cat.defaultCat == "true"){
            this.MainCat = cat.name;
          }
        })
      }else{
        this.MainCat = cat;
      }
     
      let self = this;
            await self.doPost({}, 'getglobalinfo', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data[0];
          self.titelCount = result.titelCount;
         

        }
      })
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });

      async function Main(blub) {
        self.options.isUploading = true;
        const file = blub;
        let baseFile = await toBase64(file);

        let puffer = self.newImg.type.split("/");

        let uploadData = {
          file: baseFile,
          cat: self.MainCat,
          imgName: 'hero' + self.titelCount + "." + puffer[1],
          name: self.newImg.name,
          nameImg: self.imgName
        }

        uploadData.dir = 'titleImgs/' + uploadData.imgName,
        self.doPost({data: uploadData}, 'uploadFirstImage', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            self.options.isUploading = false;
            self.updateCounter();
          }
        });
      }

      if (this.newImg == "" || this.newImg == null || this.imgName == null || this.imgName == "") {
        this.options.isUploading = false;
        if(self.options.Lang == self.options.German){
              self.showErrorMsg(self.options.Lang.neues_Bild_auswählen)
            }else{
              self.showErrorMsg(self.options.Lang.neues_Bild_auswählen)
            }
      } else {
        this.renderComp = false;
        await Main(this.newImg);
        await this.getAllImgs();
        await this.buildSelectedImgs();
        this.renderComp = true;
      }
    },
    async updateCounter(){
      let self = this;
      let updateData = {
              titelCount: self.titelCount + 1
            }
            await self.doPost({ data: updateData }, 'updateTitelCount', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
         
        }
      });
      await self.getAllImgs();
      await self.buildSelectedImgs();
      self.renderComp = true;
    },
   
  }
};
</script>
<style scoped>

.contentEdit3{
  position: absolute;
  top: 27%;
  padding: 3rem;
  background-color: #fff;
  width: 60%;
  height: 22rem;
  left: 15%;
}

#lastQuestion{
  z-index: 1111111;
  width: 50%;
  left: 20%;
}
.noContent{
  display: none;
}
.md-list-item-content{
  display: unset !important;
}
.kategorieHolder{
  margin-bottom: 1rem;
}
.contentCat{
  padding: 2rem;
  width: 100%;
}

h1 {
  font-size: 32px;
}



@media only screen and (max-width: 1500px) {
 
}

@media only screen and (max-width: 1240px) {


}

@media only screen and (max-width: 1140px) {
 
}

#imgName{
  -webkit-text-fill-color: black !important;
}
</style>